var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6539 2.72088L5.91331 12.0637L0.574219 6.71736L1.39974 5.89296L5.83287 10.3321L12.7555 1.97656L13.6539 2.72088Z",
    fill: "#67B75A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenSuccessIcon);
export default __webpack_public_path__ + "static/media/greenSuccessIcon.46cc2ba2fe745476e0305797d60c39e7.svg";
export { ForwardRef as ReactComponent };